import React from 'react';
import PropTypes from 'prop-types';

import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import BaseDialog from '../../../../components/BaseDialog/BaseDialog';
import BlockModal from '../../../../components/BlockModal/BlockModal';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

import { getString } from '../../../../helpers/stringHelpers';
import constants from '../../../../constants.js';

const stringsComponent = 'contactDetails';

const WAIT_INTERVAL = 250;

class ContactDetailsForm extends React.Component {
  constructor(props) {
    super(props);

    const { initialDialogData } = props;

    this.state = {
      dialogData: initialDialogData,
      mobilePhoneError: false,
      mobilePhoneNameError: false,
      preferredPhoneError: false,
      preferredPhoneNameError: false,
      emailError: false,
      error: false,
      dirty: false,
      blockModalOpen: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleBlockModalCancel = this.handleBlockModalCancel.bind(this);
    this.handleBlockModalConfirm = this.handleBlockModalConfirm.bind(this);
    this.validate = this.validate.bind(this);
  }

  componentDidMount() {
    this.timer = null;
  }

  handleChange(event) {
    clearTimeout(this.timer);
    const target = event.target.name;
    const value = event.target.value;

    const newDialogData = { ...this.state.dialogData };
    newDialogData[target] = value;

    this.setState({
      dialogData: newDialogData,
    });

    // We set an error, so the button is disabled until validation is run
    this.setState({ error: true });
    this.timer = setTimeout(this.validate, WAIT_INTERVAL);
  }

  handleCancel() {
    const { handleCancel } = this.props;
    const { dirty } = this.state;

    if (dirty) {
      this.setState({
        blockModalOpen: true,
      });
    } else {
      handleCancel();
    }
  }

  handleSubmit() {
    const { buttonAction } = this.props;

    buttonAction(this.state.dialogData);
  }

  handleBlockModalCancel() {
    this.setState({
      blockModalOpen: false,
    });
  }

  handleBlockModalConfirm() {
    const { handleCancel } = this.props;

    this.setState({ blockModalOpen: false });
    handleCancel();
  }

  validate() {
    const phoneReg = constants.PHONE_REGEX;
    const emailReg = constants.EMAIL_REGEX;
    const nameReg = new RegExp(`.{${constants.NAME_MIN_LENGTH},}`);

    const { dialogData } = this.state;
    const { initialDialogData } = this.props;

    this.setState(
      {
        mobilePhoneError:
          ((dialogData.mobilePhoneName || initialDialogData.mobilePhoneName) &&
            !dialogData.mobilePhone) ||
          (!phoneReg.test(dialogData.mobilePhone) &&
            (initialDialogData.mobilePhone != dialogData.mobilePhone ||
              initialDialogData.mobilePhoneName != dialogData.mobilePhoneName))
            ? true
            : false,
        mobilePhoneNameError:
          (dialogData.mobilePhone ||
            initialDialogData.mobilePhone ||
            dialogData.mobilePhoneName) &&
          (dialogData.mobilePhoneName ||
            initialDialogData.mobilePhoneName ||
            initialDialogData.mobilePhone != dialogData.mobilePhone) &&
          (!nameReg.test(dialogData.mobilePhoneName.trim()) ||
            dialogData.mobilePhoneName.length < constants.NAME_MIN_LENGTH)
            ? true
            : false,
        preferredPhoneError:
          ((dialogData.preferredPhoneName ||
            initialDialogData.preferredPhoneName) &&
            !dialogData.preferredPhone) ||
          (!phoneReg.test(dialogData.preferredPhone) &&
            (initialDialogData.preferredPhone != dialogData.preferredPhone ||
              initialDialogData.preferredPhoneName !=
                dialogData.preferredPhoneName))
            ? true
            : false,
        preferredPhoneNameError:
          (dialogData.preferredPhone ||
            initialDialogData.preferredPhone ||
            dialogData.preferredPhoneName) &&
          (dialogData.preferredPhoneName ||
            initialDialogData.preferredPhoneName ||
            initialDialogData.preferredPhone != dialogData.preferredPhone) &&
          (!nameReg.test(dialogData.preferredPhoneName.trim()) ||
            dialogData.preferredPhoneName.length < constants.NAME_MIN_LENGTH)
            ? true
            : false,
        emailError:
          (initialDialogData.email || dialogData.email) &&
          !emailReg.test(dialogData.email) &&
          initialDialogData.email != dialogData.email
            ? true
            : false,
      },
      () => {
        this.setState({
          error:
            this.state.mobilePhoneError ||
            this.state.mobilePhoneNameError ||
            this.state.preferredPhoneError ||
            this.state.preferredPhoneNameError ||
            this.state.emailError,
          dirty:
            initialDialogData.mobilePhone != dialogData.mobilePhone ||
            initialDialogData.mobilePhoneName != dialogData.mobilePhoneName ||
            initialDialogData.preferredPhone != dialogData.preferredPhone ||
            initialDialogData.preferredPhoneName !=
              dialogData.preferredPhoneName ||
            initialDialogData.email != dialogData.email,
        });
      }
    );
  }

  render() {
    const {
      open,
      title,
      content,
      buttonLabel,
      secondaryButtonLabel,
      secondaryButtonAction,
      supplementaryButtonLabel,
      supplementaryButtonAction,
      icon,
      classes,
      inlineTitle,
      initialDialogData,
      readOnly,
    } = this.props;

    const {
      dialogData,
      mobilePhoneError,
      mobilePhoneNameError,
      preferredPhoneError,
      preferredPhoneNameError,
      emailError,
      blockModalOpen,
      error,
    } = this.state;

    return (
      <BaseDialog
        open={open}
        largeTitle={true}
        title={title}
        content={
          <div className={classes.dialogContent}>
            {content}
            <div className={classes.formContainer}>
              <div className={classes.formField}>
                <Typography className={classes.label}>
                  {getString(stringsComponent, 'MAINTENANCE_MOBILE_LABEL')}
                </Typography>
                <TextField
                  variant='outlined'
                  className={classes.textFieldContainer}
                  placeholder={getString(stringsComponent, 'MOBILE_EXAMPLE')}
                  inputProps={{
                    className: classes.textInput,
                  }}
                  name='mobilePhone'
                  value={dialogData.mobilePhone}
                  onChange={this.handleChange}
                  disabled={readOnly}
                />
              </div>
              <Typography component='div' className={classes.validation}>
                {mobilePhoneError
                  ? getString(stringsComponent, 'MAINTENANCE_PHONE_HELP_TEXT')
                  : ''}
              </Typography>
              <br />
              <div className={classes.formField}>
                <Typography className={classes.label}>
                  {getString(stringsComponent, 'MAINTENANCE_MOBILE_NAME_LABEL')}
                </Typography>
                <TextField
                  variant='outlined'
                  className={classes.textFieldContainer}
                  placeholder={getString(
                    stringsComponent,
                    'MOBILE_NAME_EXAMPLE'
                  )}
                  inputProps={{
                    className: classes.textInput,
                  }}
                  name='mobilePhoneName'
                  value={dialogData.mobilePhoneName}
                  onChange={this.handleChange}
                  disabled={readOnly}
                />
              </div>
              <Typography component='div' className={classes.validation}>
                {mobilePhoneNameError
                  ? getString(
                      stringsComponent,
                      'MAINTENANCE_REQUIRED_HELP_TEXT'
                    )
                  : ''}
              </Typography>
              <br />
              <div className={classes.formField}>
                <Typography className={classes.label}>
                  {getString(stringsComponent, 'MAINTENANCE_PHONE_LABEL')}
                </Typography>
                <TextField
                  variant='outlined'
                  className={classes.textFieldContainer}
                  placeholder={getString(stringsComponent, 'PHONE_EXAMPLE')}
                  inputProps={{
                    className: classes.textInput,
                  }}
                  name='preferredPhone'
                  value={dialogData.preferredPhone}
                  onChange={this.handleChange}
                  disabled={readOnly}
                />
              </div>
              <Typography component='div' className={classes.validation}>
                {preferredPhoneError
                  ? getString(stringsComponent, 'MAINTENANCE_PHONE_HELP_TEXT')
                  : ''}
              </Typography>
              <br />
              <div className={classes.formField}>
                <Typography className={classes.label}>
                  {getString(stringsComponent, 'MAINTENANCE_PHONE_NAME_LABEL')}
                </Typography>
                <TextField
                  variant='outlined'
                  className={classes.textFieldContainer}
                  inputProps={{
                    className: classes.textInput,
                  }}
                  name='preferredPhoneName'
                  value={dialogData.preferredPhoneName}
                  onChange={this.handleChange}
                  placeholder={getString(
                    stringsComponent,
                    'PHONE_NAME_EXAMPLE'
                  )}
                  disabled={readOnly}
                />
              </div>
              <Typography component='div' className={classes.validation}>
                {preferredPhoneNameError
                  ? getString(
                      stringsComponent,
                      'MAINTENANCE_REQUIRED_HELP_TEXT'
                    )
                  : ''}
              </Typography>
              <br />
              <div className={classes.formField}>
                <Typography className={classes.label}>
                  {getString(stringsComponent, 'MAINTENANCE_EMAIL_LABEL')}
                </Typography>
                <TextField
                  variant='outlined'
                  className={classes.textFieldContainer}
                  inputProps={{
                    className: classes.textInput,
                  }}
                  name='email'
                  value={dialogData.email}
                  onChange={this.handleChange}
                  placeholder={getString(stringsComponent, 'EMAIL_EXAMPLE')}
                  disabled={readOnly}
                />
              </div>
              <Typography component='div' className={classes.validation}>
                {emailError
                  ? getString(stringsComponent, 'MAINTENANCE_EMAIL_HELP_TEXT')
                  : ''}
              </Typography>

              <BlockModal
                show={blockModalOpen}
                message={getString('blockModal', 'MESSAGE')}
                cancel={this.handleBlockModalCancel}
                ok={this.handleBlockModalConfirm}
                secondaryButtonLabel={getString(
                  'blockModal',
                  'BUTTON_LABEL_CANCEL'
                )}
              />
            </div>
          </div>
        }
        buttonAction={this.handleSubmit}
        buttonLabel={buttonLabel}
        buttonDisabled={error}
        secondaryButtonAction={secondaryButtonAction}
        secondaryButtonLabel={secondaryButtonLabel}
        supplementaryButtonAction={supplementaryButtonAction}
        supplementaryButtonLabel={supplementaryButtonLabel}
        icon={icon}
        contentWrap={false}
        inlineTitle={inlineTitle}
      />
    );
  }
}

ContactDetailsForm.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  buttonAction: PropTypes.func.isRequired,
  secondaryButtonLabel: PropTypes.string.isRequired,
  secondaryButtonAction: PropTypes.func.isRequired,
  supplementaryButtonLabel: PropTypes.string.isRequired,
  supplementaryButtonAction: PropTypes.func.isRequired,
  icon: PropTypes.func.isRequired,
  inlineTitle: PropTypes.bool,
  readOnly: PropTypes.bool,
};

ContactDetailsForm.defaultProps = {
  inlineTitle: false,
  readOnly: false,
};

export default withStyles(styles, { withTheme: true })(ContactDetailsForm);
